<footer class="footer-responsive primary-bgpurple">
    <div class="container">
        <div class="row g-lg-5 g-lg-5" id="footerAccordion">
            <div
                class="col-lg-3 col-8 d-flex align-items-lg-center align-items-lg-center justify-content-lg-start justify-content-center my-3 mb-lg-0">
                <img [src]="'cdn/ghrus-logo.webp' | cdnImage" alt="GHRU Saikheda logo"
                    width="500" height="157" loading="lazy" class="img-fluid w-100">
            </div>
            <div class="col-lg-3 ">
                <div class="accordion-item">
                    <h2 class="accordion-header h6 fw-semibold" id="h1">
                        <a class="accordion-button" href="#c1" role="button" data-bs-toggle="collapse"
                            aria-expanded="true" aria-controls="c1">
                            IMPORTANT LINKS
                        </a>
                    </h2>
                    <div id="c1" class="accordion-collapse collapse show" aria-labelledby="h1"
                        data-bs-parent="#footerAccordion">
                        <div class="accordion-body">
                            <ul>
                                <li><a href="http://admissions.ghru.edu.in/" target="_blank"> Apply Now</a></li>
                                <li><a routerLink="/admission/admission-procedure">Admission Procedure</a></li>
                                <!-- <li><a href="student-scholarship"> Students Scholarship</a></li> -->
                                <li><a routerLink="/programs-offered">Programs Offered</a></li>
                                <li><a href="blogs">Blogs</a></li>
                                <!-- <li><a href="javascript:void(0);" target="_blank">Education Loan</a></li> -->
                                <li><a href="https://hobbyclubs.raisoni.net/" target="_blank">Hobby Clubs</a></li>
                                <li><a href="https://ghrutbif.com/apply-for-incubation" target="_blank">Apply for
                                        Incubation</a>
                                </li>

                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-2">
                <div class="accordion-item">
                    <h2 class="accordion-header h6 fw-semibold" id="h2">
                        <a class="accordion-button collapsed" href="#c2" role="button" data-bs-toggle="collapse"
                            aria-expanded="false" aria-controls="c2">
                            PORTALS
                        </a>
                    </h2>
                    <div id="c2" class="accordion-collapse collapse" aria-labelledby="h2"
                        data-bs-parent="#footerAccordion">
                        <div class="accordion-body">
                            <ul>
                                <li><a href="https://alumni.raisoni.net/" target="_blank">Alumni Portal</a></li>
                                <!-- <li><a href="https://www.rashtriyachhatrasansad.in/" target="_blank">NSP</a></li> -->
                                <!-- <li><a href="http://nationalagricultureconclave.com/" target="_blank">NAC</a></li> -->
                                <li><a href="https://currentopenings.raisoni.net/" target="_blank">Current Openings</a>
                                </li>
                                <li><a href="https://sgrkf.com/" target="_blank">SGRKF</a></li>
                                <li><a href="http://ghrscf.com/" target="_blank">GHRSCF</a></li>
                                <li><a href="https://ghrutbif.com/" target="_blank">GHRUTBIF</a></li>

                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-3">
                <div class="accordion-item">
                    <h2 class="accordion-header h6 fw-semibold" id="h3">
                        <a class="accordion-button collapsed" href="#c3" role="button" data-bs-toggle="collapse"
                            aria-expanded="false" aria-controls="c3">
                            Address
                        </a>
                    </h2>
                    <div id="c3" class="accordion-collapse collapse" aria-labelledby="h3"
                        data-bs-parent="#footerAccordion">
                        <div class="accordion-body">
                            <ul class="contact">
                                <li><a href="https://goo.gl/maps/uoAnEaAXSp9Kr3WZA" target="_blank" rel="noopener noreferrer"> <i
                                            class="material-symbols-outlined" aria-hidden="true">location_on</i> G H Raisoni Nagar, Gram Doda Borgaon, Teh.
                                        Sausar,

                                        Dist. Pandhurna 480337 (MP)</a></li>
                                <li> <i class="material-symbols-outlined text-white" aria-hidden="true">call</i> <a href="tel:9111104290"> 9111104290 /</a>
                                    <a href="tel:9111104291">9111104291</a>
                                </li>
                                <li><a href="mailto:info@ghru.edu.in"> <i class="material-symbols-outlined" aria-hidden="true">mail</i>
                                        info@ghru.edu.in</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div class="row justify-content-lg-end justify-content-center py-lg-0 py-3">
            <div class="col-lg-4 ps-4 social-links text-lg-start text-center">

                <a href="https://www.facebook.com/ghruofficial" target="_blank" aria-label="Facebook">
                    <app-icon name="facebook"></app-icon></a>

                <a href="https://www.instagram.com/ghruofficial" target="_blank" aria-label="Instagram">
                    <app-icon name="instagram"></app-icon></a>

                <a href="https://twitter.com/ghruofficial" target="_blank" aria-label="Twitter">
                    <app-icon name="twitter"></app-icon></a>

                <a href="https://www.linkedin.com/school/68193739/admin/" target="_blank" aria-label="LinkedIn">
                    <app-icon name="linkedin"></app-icon></a>

                <a href="https://www.youtube.com/c/GHRUOFFICIAL" target="_blank" aria-label="YouTube">
                    <app-icon name="youtube"></app-icon></a>

            </div>
        </div>
        <div class="row mt-lg-1 justify-content-between flex-row-reverse g-3 g-lg-0 pt-3 pt-0">

            <div class="col-lg-5">
                <div class="text-lg-end text-center privacy">
                    <a href="https://ghru.edu.in/document/privacy_policy.html" target="_blank">Privacy Policy</a> | <a
                        href="https://ghru.edu.in/document/terms_and_conditions.html" target="_blank"> Terms &amp;
                        Conditions</a> | <a href="https://ghru.edu.in/document/refund_and_cancellation.html"
                        target="_blank">Refund &amp; Cancellation </a>
                </div>
            </div>
            <div class="col-lg-6">
                <p class="mb-0">&copy; {{currentyear}} All Rights Reserved. Design & Developed by
                    <a href="https://globaledu.net.in/" target="_blank">Global
                        Education Limited.</a>
                </p>
            </div>
        </div>
    </div>
</footer>
